// PRO Drift Auditor -- shared number/colour formatting helpers.

export const fmtMoney = (v: number): string =>
    `$${Math.round(v).toLocaleString('en-US')}`;

export const fmtMoneySigned = (v: number): string =>
    `${v >= 0 ? '+' : '-'}$${Math.round(Math.abs(v)).toLocaleString('en-US')}`;

export const fmtMoneyShort = (v: number): string => {
    const a = Math.abs(v);
    if (a >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
    if (a >= 1_000) return `$${(v / 1_000).toFixed(0)}k`;
    return `$${v.toFixed(0)}`;
};

export const fmtPct = (v: number, digits = 2): string => `${v.toFixed(digits)}%`;

export const fmtPctSigned = (v: number, digits = 2): string =>
    `${v >= 0 ? '+' : ''}${v.toFixed(digits)}%`;

export const fmtNum = (v: number, digits = 2): string => v.toFixed(digits);

// Positive => emerald, negative => rose, zero => amber. Tailwind text classes.
export const signClass = (v: number): string =>
    v > 0
        ? 'text-emerald-600 dark:text-emerald-400'
        : v < 0
          ? 'text-rose-600 dark:text-rose-400'
          : 'text-amber-600 dark:text-amber-400';

// Deterministic, high-contrast categorical palette for per-ticker series.
export const TICKER_PALETTE: readonly string[] = [
    '#6366f1', // indigo
    '#10b981', // emerald
    '#f59e0b', // amber
    '#f43f5e', // rose
    '#0ea5e9', // sky
    '#8b5cf6', // violet
    '#14b8a6', // teal
    '#ec4899', // pink
    '#84cc16', // lime
    '#f97316', // orange
    '#06b6d4', // cyan
    '#a855f7', // purple
];

export const tickerColor = (index: number): string =>
    TICKER_PALETTE[index % TICKER_PALETTE.length];
